import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ChangeSubCategoryPositionContext,
	IChangeSubCategoryPositionContext,
} from '../../../../changeSubCategoryPositionState/changeSubCategoryPositionContext';
import classNames from 'classnames';
import style from './ResetBtn.module.scss';

export const ResetBtn: React.FC = () => {
	const { resetSelectedControls, selectedRestaurant, IDSelectedCategory } =
		useContext<IChangeSubCategoryPositionContext>(ChangeSubCategoryPositionContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: selectedRestaurant || IDSelectedCategory,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};
